<template>
  <el-footer>
    <div class="footer-container">
      <div class="feature-container" v-if="featureList.length > 0">
        <div class="fc-content">
          <div class="fcc-item" v-for="(v,i) in featureList" :key="i">
            <el-image :src="v.image"></el-image>
            <div class="name">{{ v.name }}</div>
          </div>
        </div>
      </div>
      <div class="fc-container">
        <div class="fc-main">
          <div class="m-left">
            <div class="ml-1">
              <div class="title">
                <div class="t-value">首页</div>
                <div class="line"></div>
              </div>
              <div class="nav">
                <div class="nav-item" @click="$router.push('/news')">新闻资讯</div>
              </div>
            </div>
            <div class="ml-2">
              <div class="title">
                <div class="t-value">服务中心</div>
                <div class="line"></div>
              </div>
              <div class="nav">
                <div class="nav-item" @click="$router.push('/product/classify?classifyId=1&name=我要检测')">
                  我要检测
                </div>
                <div class="nav-item" @click="$router.push('/product/classify?classifyId=2&name=我要认证')">
                  我要认证
                </div>
                <div class="nav-item" @click="$router.push('/product/classify?classifyId=3&name=考证/培训')">
                  考证/培训
                </div>
                <!--<div class="nav-item" @click="$router.push('/product/classify?classifyId=4&name=分析仪器')">-->
                <!--  分析仪器-->
                <!--</div>-->
                <!--<div class="nav-item" @click="$router.push('/product/classify?classifyId=5&name=实验设备')">-->
                <!--  实验设备-->
                <!--</div>-->
              </div>
            </div>
            <div class="ml-3">
              <div class="title">
                <div class="t-value">便捷入口</div>
                <div class="line"></div>
              </div>
              <div class="nav">
                <div class="nav-item" @click="$router.push('/inquiry')">我要查询</div>
                <div class="nav-item" @click="$router.push('/qrcode')">二维码生成器</div>
                <div class="nav-item" @click="$router.push('/joins?classifyId=1')">我要加盟</div>
              </div>
            </div>
            <div class="ml-4">
              <div class="title">
                <div class="t-value">关于我们</div>
                <div class="line"></div>
              </div>
              <div class="nav">
                <div class="nav-item" @click="$router.push({path:'/about',hash:'#grow'})">发展历程</div>
                <div class="nav-item" @click="$router.push({path:'/about',hash:'#honor'})">荣誉资讯</div>
                <div class="nav-item" @click="showJoinUs = true">诚聘英才</div>
                <div class="nav-item" @click="showLegalNotice = true">法律声明</div>
              </div>
            </div>
            <div class="ml-5">
              <div class="title">
                <div class="t-value">服务热线</div>
                <div class="line"></div>
              </div>
              <div class="nav">
                <div class="nav-item phone">客服电话：<a :href="'tel:'+websiteConfig.customerServicePhone">{{ websiteConfig.customerServicePhone }}</a></div>
                <div class="nav-item">邮箱：{{ websiteConfig.companyEmail }}</div>
                <div class="nav-item">地址：{{ websiteConfig.companyAddress }}</div>
              </div>
            </div>
          </div>
          <div class="m-line"></div>
          <div class="m-right">
            <div class="title">
              <div class="t-value">请添加专属客服微信</div>
              <div class="line"></div>
            </div>
            <div class="qrcode">
              <div class="q-left">
                <el-image :src="websiteConfig.mpImage"></el-image>
                <div class="name">商务合作</div>
              </div>
              <div class="q-right">
                <el-image :src="websiteConfig.officialWebsiteImage"></el-image>
                <div class="name">官网</div>
              </div>
            </div>
          </div>
        </div>
        <div class="copyright-beian-jingbei">
          <div class="copyright">{{ websiteConfig.copyright }}</div>
          <div class="beian">
            <a href="https://beian.miit.gov.cn" target="_blank">{{ websiteConfig.filingNumber }}</a>
          </div>
          <div class="jingbei">
            <el-image class="gongan" :src="require('@/assets/layout/gongan.png')"></el-image>
            {{ websiteConfig.safetyNumber }}
          </div>
        </div>
      </div>
    </div>
    <!--    法律声明-->
    <legal-notice-layer :visible.sync="showLegalNotice"/>
    <!--    诚聘英才-->
    <join-us-layer :visible.sync="showJoinUs"/>
  </el-footer>
</template>

<script>
import {getWebsiteConfig} from "@/utils/website-config";
import LegalNoticeLayer from "./LegalNoticeLayer.vue";
import JoinUsLayer from "./JoinUsLayer.vue";

export default {
  name: "CFooter",
  components: {LegalNoticeLayer, JoinUsLayer},
  data() {
    return {
      featureList: [],
      showLegalNotice: false,
      showJoinUs: false
    }
  },
  computed: {
    // 网站配置
    websiteConfig() {
      const config = getWebsiteConfig()
      this.featureList = config.featureList
      return config
    }
  }
}
</script>

<style scoped lang="scss">
.el-footer {
  width: 100%;
  padding: 0;
  height: auto !important;
  display: flex;
  flex-direction: row;
  justify-content: center;


  .footer-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .feature-container {
      background-color: #F1F5FF;
      width: 100%;
      height: 164px;
      display: flex;
      flex-direction: row;
      justify-content: center;

      .fc-content {
        width: 1200px;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .fcc-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .el-image {
            width: 64px;
            height: 64px;
          }

          .name {
            color: #2D2D2D;
            font-size: 20px;
            margin-top: 10px;
          }
        }
      }
    }

    .fc-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      background-color: #2C2F34;

      .fc-main {
        width: 1200px;
        padding: 35px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .m-left {
          width: 858px;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .ml-1, .ml-2, .ml-3, .ml-4 {
            .nav .nav-item {
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }
          }

          .ml-1, .ml-2, .ml-3, .ml-4, .ml-5 {
            height: 100%;
            display: flex;
            flex-direction: column;

            .nav {
              margin-top: 20px;
              display: flex;
              flex-direction: column;

              .nav-item {
                color: #FFFFFF;
                margin-top: 10px;
                font-size: 15px;

                &:first-child {
                  margin-top: 0;
                }
              }
            }
          }

          .ml-5 .nav .phone {
            font-size: 24px;
            font-weight: bold;

            a {
              color: #FF3E4A;
              text-decoration: none;
            }
          }
        }

        .m-line {
          height: 100%;
          width: 1px;
          background-color: #4D5158;
          margin: 0 50px;
        }

        .m-right {
          display: flex;
          flex-direction: column;

          .qrcode {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 20px;

            .q-left, .q-right {
              display: flex;
              flex-direction: column;
              align-items: center;

              .el-image {
                width: 100px;
                height: 100px;
              }

              .name {
                font-size: 14px;
                color: #FFFFFF;
                margin-top: 5px;
              }
            }

            .q-right {
              margin-left: 15px;
            }
          }
        }

        .title {
          display: flex;
          flex-direction: column;

          .t-value {
            font-size: 16px;
            color: #FFFFFF;
            font-weight: bold;
          }

          .line {
            background-color: #0065f6;
            width: 40px;
            height: 3px;
            border-radius: 10px;
          }
        }
      }

      .copyright-beian-jingbei {
        width: 100%;
        color: #656565;
        font-size: 14px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        border-top: 1px solid #4D5158;
        padding: 15px 0;

        div {
          padding: 0 50px;

          &.beian a {
            text-decoration: none;
            color: #656565;

            &:hover {
              text-decoration: underline;
            }
          }

          &.jingbei {
            display: flex;
            flex-direction: row;
            align-content: center;

            .gongan {
              padding: 0 2px 0 0;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>